<template>
  <div>
    <form
      @submit.prevent="handleSignup"
      class="block sign_in landscape:mx-auto"
    >
      <!-- sign in form  -->
      <div
        class="w-full bg-white landscape:p-3 md:rounded-l-0 rounded-l-lg rounded-r-lg flex items-center justify-center text-gray-950 text-center relative"
      >
        <div class="w-full max-w-md">
          <div class="mb-5">
            <div class="mb-5 flex items-center justify-center">
              <a href="ireserve.shop" title="iReserve Shop">
                <img src="/logo2.png" width="95px" height="15px" />
              </a>
            </div>
            <div
              class="block text-sm sm:text-base text-center px-2 mb-2 font-normal text-gray-600"
            >
              Once you start selling on HiSell you'll never want to go back to
              selling on social media! its so easy and you dont even have to be
              there.
            </div>
          </div>
          <p :class="messageClass" class="text-xs py-2 px-2 text-left relative">
            {{ message }}
          </p>
          <div class="mb-[40px]">
            <div class="relative mb-2">
              <input
                type="text"
                id="fullname"
                name="fullname"
                v-model="fullname"
                @input="
                  fullname = fullname
                    .toLowerCase()
                    .split(' ')
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ')
                "
                v-on:blur="validateFullName"
                title="Enter your full name"
                :disabled="loading"
                required
                class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-950 bg-transparent border border-t-0 border-r-0 border-l-0 border-gray-400 appearance-none focus:outline-none focus:ring-0 focus:border-gray-800 peer"
                placeholder=""
              />
              <label
                for="fullname"
                class="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-800 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                >Full name</label
              >
              <span
                class="absolute top-1/2 right-2 -translate-y-1/2 text-gray-400"
              >
                <i class="fa-solid fa-user"></i>
              </span>
            </div>
            <div
              v-if="fullnameError"
              class="text-red-500 text-xs py-2 px-2 text-left relative"
            >
              More than one name required!
            </div>
            <div class="relative mb-2">
              <input
                type="email"
                id="useremail"
                name="useremail"
                v-model="useremail"
                @input="useremail = useremail.toLowerCase()"
                v-on:blur="emailExist"
                title="Enter your Email"
                :disabled="loading || staff"
                required
                class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-950 bg-transparent border border-t-0 border-r-0 border-l-0 border-gray-400 appearance-none focus:outline-none focus:ring-0 focus:border-gray-800 peer"
                placeholder=""
              />
              <label
                for="useremail"
                class="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-800 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                >E-mail address</label
              >
              <span
                class="absolute top-1/2 right-2 -translate-y-1/2 text-gray-400"
              >
                <i class="fa-solid fa-at"></i>
              </span>
            </div>
            <div
              v-if="useremailError"
              class="text-red-500 text-xs py-2 px-2 text-left relative"
            >
              User already exist
            </div>
            <div
              v-if="emailError"
              class="text-red-500 text-xs py-2 px-2 text-left relative"
            >
              Invalid email format
            </div>
            <div class="relative mb-2">
              <input
                :type="showPassword ? 'text' : 'password'"
                id="password"
                name="password"
                title="Enter your password"
                v-model="password"
                :disabled="loading"
                @input="passwordValid"
                required
                class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-950 bg-transparent border border-t-0 border-r-0 border-l-0 border-gray-400 appearance-none focus:outline-none focus:ring-0 focus:border-gray-600 peer"
                placeholder=""
              />
              <label
                for="password"
                class="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                >Password</label
              >

              <div
                class="absolute top-1/2 right-2 -translate-y-1/2 flex items-center gap-2"
              >
                <button
                  @click="showPassword = !showPassword"
                  type="button"
                  class="text-gray-400 hover:text-gray-600"
                >
                  <i
                    :class="
                      showPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'
                    "
                  ></i>
                </button>
                <i class="fa-solid fa-lock text-gray-400"></i>
              </div>
            </div>
            <div
              v-if="passwordError"
              class="bg-gray-50 rounded-lg p-4 mb-3 transition-all duration-300"
            >
              <p class="text-sm font-medium text-gray-700 mb-3 text-start">
                Password must include:
              </p>
              <ul class="space-y-2 text-xs">
                <li class="flex items-center gap-2">
                  <span
                    class="w-4 h-4 flex items-center justify-center rounded-full text-white text-xs"
                    :class="[
                      /[A-Z]/.test(password) ? 'bg-green-500' : 'bg-red-400',
                    ]"
                  >
                    <i
                      :class="[
                        /[A-Z]/.test(password)
                          ? 'fas fa-check'
                          : 'fas fa-times',
                      ]"
                    ></i>
                  </span>
                  <span
                    :class="[
                      /[A-Z]/.test(password)
                        ? 'text-green-600'
                        : 'text-red-500',
                    ]"
                  >
                    One uppercase letter (A–Z)
                  </span>
                </li>

                <li class="flex items-center gap-2">
                  <span
                    class="w-4 h-4 flex items-center justify-center rounded-full text-white text-xs"
                    :class="[
                      /[a-z]/.test(password) ? 'bg-green-500' : 'bg-red-400',
                    ]"
                  >
                    <i
                      :class="[
                        /[a-z]/.test(password)
                          ? 'fas fa-check'
                          : 'fas fa-times',
                      ]"
                    ></i>
                  </span>
                  <span
                    :class="[
                      /[a-z]/.test(password)
                        ? 'text-green-600'
                        : 'text-red-500',
                    ]"
                  >
                    One lowercase letter (a–z)
                  </span>
                </li>

                <li class="flex items-center gap-2">
                  <span
                    class="w-4 h-4 flex items-center justify-center rounded-full text-white text-xs"
                    :class="[
                      /\d/.test(password) ? 'bg-green-500' : 'bg-red-400',
                    ]"
                  >
                    <i
                      :class="[
                        /\d/.test(password) ? 'fas fa-check' : 'fas fa-times',
                      ]"
                    ></i>
                  </span>
                  <span
                    :class="[
                      /\d/.test(password) ? 'text-green-600' : 'text-red-500',
                    ]"
                  >
                    One number (0–9)
                  </span>
                </li>

                <li class="flex items-center gap-2">
                  <span
                    class="w-4 h-4 flex items-center justify-center rounded-full text-white text-xs"
                    :class="[
                      /[!@#$%^&*_\-+=?]/.test(password)
                        ? 'bg-green-500'
                        : 'bg-red-400',
                    ]"
                  >
                    <i
                      :class="[
                        /[!@#$%^&*_\-+=?]/.test(password)
                          ? 'fas fa-check'
                          : 'fas fa-times',
                      ]"
                    ></i>
                  </span>
                  <span
                    :class="[
                      /[!@#$%^&*_\-+=?]/.test(password)
                        ? 'text-green-600'
                        : 'text-red-500',
                    ]"
                  >
                    One special character (! @ # $ % ^ & * - _ + = ?)
                  </span>
                </li>

                <li class="flex items-center gap-2">
                  <span
                    class="w-4 h-4 flex items-center justify-center rounded-full text-white text-xs"
                    :class="[
                      password && password.length >= 12
                        ? 'bg-green-500'
                        : 'bg-red-400',
                    ]"
                  >
                    <i
                      :class="[
                        password && password.length >= 12
                          ? 'fas fa-check'
                          : 'fas fa-times',
                      ]"
                    ></i>
                  </span>
                  <span
                    :class="[
                      password && password.length >= 12
                        ? 'text-green-600'
                        : 'text-red-500',
                    ]"
                  >
                    Minimum length of 12 characters
                  </span>
                </li>
              </ul>
            </div>
            <div v-else>
              <div class="relative mb-2">
                <input
                  type="password"
                  id="confirmpassword"
                  name="confirmpassword"
                  title="Re-enter your password"
                  v-model="confirmpassword"
                  @input="passwordsMatch"
                  :disabled="loading"
                  required
                  class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-950 bg-transparent border border-t-0 border-r-0 border-l-0 border-gray-400 appearance-none focus:outline-none focus:ring-0 focus:border-gray-600 peer"
                  placeholder=""
                />
                <label
                  for="confirmpassword"
                  class="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >Confirm password</label
                >
                <span
                  class="absolute top-1/2 right-2 -translate-y-1/2 text-gray-400"
                >
                  <!-- Lock icon as inline SVG -->
                  <i class="fa-solid fa-lock"></i>
                </span>
              </div>
              <div
                v-if="passwordsMatchError"
                class="text-red-500 text-xs py-2 px-2 text-left relative"
              >
                Passwords do not match!
              </div>
              <div class="flex items-center justify-between mt-4">
                <div class="inline-flex items-center">
                  <label
                    class="relative flex items-center p-1 rounded-full cursor-pointer"
                    htmlFor="termofusage"
                    title="You will be remembered for the next 24 hours"
                  >
                    <input
                      type="checkbox"
                      name="termofusage"
                      :disabled="loading"
                      v-model="termofusage"
                      class="before:content[''] peer relative h-4 w-4 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-button checked:bg-button checked:before:bg-button hover:before:opacity-10"
                      id="termofusage"
                    />
                    <span
                      class="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-3.5 w-3.5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        stroke="currentColor"
                        stroke-width="1"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </span>
                  </label>
                  <label
                    class="mt-px font-light text-button cursor-pointer select-none"
                    htmlFor="termofusage"
                  >
                    <div>
                      <p
                        class="block text-xs antialiased font-medium leading-relaxed text-gray-500"
                        title="You will be remembered for the next 24 hours"
                      >
                        I accept the
                        <router-link
                          to="/terms-of-service"
                          class="text-linkbutton"
                          >terms of service</router-link
                        >
                        and
                        <router-link
                          to="/privacy-policy"
                          class="text-linkbutton"
                          >privacy policy</router-link
                        >
                      </p>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!passwordError">
            <div class="mb-3">
              <button
                :disabled="
                  fullnameError ||
                  useremailError ||
                  emailError ||
                  passwordError ||
                  passwordsMatchError
                "
                class="align-middle select-none font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-sm py-3.5 px-7 rounded-lg text-white shadow-md shadow-button/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none block w-full bg-button p-2"
              >
                <span
                  class="flex flex-row justify-center items-center"
                  v-if="loading"
                >
                  <svg
                    class="h-5 w-5 mr-3 animate-spin text-gray-50"
                    viewBox="0 0 64 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                  >
                    <path
                      d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                      stroke="currentColor"
                      stroke-width="5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                      stroke="currentColor"
                      stroke-width="5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="text-gray-900"
                    ></path>
                  </svg>
                  Hold on...
                </span>
                <span v-else>Create account</span>
              </button>
            </div>
            <div
              class="flex items-center w-full uppercase text-xs font-medium mb-3 text-gray-600"
            >
              <div class="flex-1 border-b border-gray-300 h-2"></div>
              <span class="px-2">Or</span>
              <div class="flex-1 border-b border-gray-300 h-2"></div>
            </div>
            <div class="mb-5">
              <button
                :disabled="googleLoading"
                @click="signupWithGoogle"
                class="align-middle select-none font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-sm py-3.5 px-7 rounded-lg border text-gray-600 hover:opacity-75 focus:ring focus:ring-gray-300 active:opacity-[0.85] w-full flex h-12 border-gray-200 items-center justify-center gap-2"
                type="button"
                data-ripple-dark="true"
              >
                <img
                  :class="{
                    'border-blue-600 rounded-full animate-spin': googleLoading,
                  }"
                  src="/logo-google.png"
                  alt="google"
                  class="h-6 w-6"
                />
                <span v-if="!googleLoading">Signup with Google</span>
                <span v-else>Processing...</span>
              </button>
            </div>
            <div
              variant="small"
              color="gray"
              class="!mt-4 text-center font-normal text-base text-gray-500"
            >
              Already have an account?
              <router-link
                to="/login"
                class="font-medium text-gray-700 underline underline-offset-2"
              >
                Login
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { GoogleSignInMod } from "@/utils/authutils";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

export default {
  name: "LoginComponent",
  data() {
    return {
      fullname: "",
      fullnameError: false,
      useremail: "",
      useremailError: false,
      emailError: false,
      password: "",
      confirmpassword: "",
      passwordError: false,
      passwordsMatchError: false,
      termofusage: false,
      message: "",
      messageClass: "",
      loading: false,
      googleLoading: false,
      staff: false,
      staffToken: null,
      storeId: null,
      showPassword: false,
    };
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.staffToken = urlParams.get("auth");

    if (this.staffToken) {
      this.fetchStaffEmail();
    }
  },
  computed: {},
  methods: {
    ...mapActions(["register", "checkEmail", "googleSignUp", "verifyInvite"]),
    passwordsMatch() {
      this.passwordsMatchError = !(this.password === this.confirmpassword);
    },
    passwordValid() {
      const isValid =
        this.password &&
        this.password.length >= 12 &&
        /[A-Z]/.test(this.password) &&
        /[a-z]/.test(this.password) &&
        /\d/.test(this.password) &&
        /[!@#$%^&*_\-+=?]/.test(this.password);

      this.passwordError = !isValid;
    },
    validateFullName() {
      this.fullnameError = !!this.fullname;
      this.fullname.split(" ").length < 2
        ? (this.fullnameError = true)
        : (this.fullnameError = false);
    },
    async fetchStaffEmail() {
      try {
        const response = await this.verifyInvite({ token: this.staffToken });
        if (response.success) {
          const data = response.data;
          if (data.redirect !== "") {
            toast.info(data.message, {
              position: "top-right",
              autoClose: 2000,
            });
            this.$router.push(data.redirect);
          }
          this.useremail = data.email;
          this.storeId = data.storeID;
          this.staff = true;
        } else {
          this.useremailError = true;
          toast.error(response.message, {
            position: "top-right",
            autoClose: 2000,
          });
        }
      } catch (error) {
        console.error("Error fetching staff email:", error);
        this.useremailError = true;
      }
    },
    async emailExist() {
      if (this.useremail) {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        this.emailError = !emailPattern.test(this.useremail);

        if (this.emailError) {
          return;
        } else {
          try {
            const response = await this.checkEmail({ email: this.useremail });
            if (response) {
              this.useremailError = true;
            } else {
              this.useremailError = false;
            }
          } catch (error) {
            console.error(error);
          }
        }
      } else {
        this.emailError = true;
      }
    },
    async handleSignup() {
      if (
        this.fullnameError ||
        this.useremailError ||
        this.emailError ||
        this.passwordError ||
        this.passwordsMatchError
      )
        return;
      this.loading = true;
      this.message = "";
      if (!this.termofusage) {
        this.message = "Accept terms of service and privacy policy to proceed!";
        this.messageClass = "text-red-500";
        this.loading = false;
        return;
      }
      let userData;

      if (this.staff) {
        userData = {
          staff: this.staff,
          staff_token: this.staffToken,
          name: this.fullname,
          email: this.useremail,
          password: this.confirmpassword,
        };
      } else {
        userData = {
          name: this.fullname,
          email: this.useremail,
          password: this.confirmpassword,
        };
      }

      try {
        const response = await this.register(userData);
        if (response.success) {
          this.message = response.message || "Registration successfull";
          this.messageClass = "text-green-500";
          const redirectPath = "/login";
          this.$router.push(redirectPath);
        } else {
          this.message = response.message || response.error;
          this.messageClass = "text-red-500";
        }
      } catch (error) {
        this.message =
          `errorMessage from view: ${error.message}` ||
          "An error occured during registration";
        this.messageClass = "text-red-500";
      } finally {
        this.loading = false;
      }
    },
    async signupWithGoogle() {
      this.message = "";
      this.googleLoading = true;
      try {
        const googleUser = await GoogleSignInMod();
        if (googleUser) {
          let userData;
          if (this.staff) {
            userData = {
              staff: this.staff,
              id_token: googleUser.id_token,
              email: googleUser.profile.email,
              fullname: googleUser.profile.name,
              image: googleUser.profile.imageUrl,
            };
          } else {
            userData = {
              id_token: googleUser.id_token,
              email: googleUser.profile.email,
              fullname: googleUser.profile.name,
              image: googleUser.profile.imageUrl,
            };
          }

          try {
            const response = await this.checkEmail({ email: userData.email });
            if (response) {
              this.message = "User already exist please login";
              this.messageClass = "text-red-500";
              return;
            } else {
              try {
                let response;
                if (this.staff) {
                  response = await this.googleSignUp({
                    userData,
                    staff_token: this.staffToken,
                  });
                } else {
                  response = await this.googleSignUp(userData);
                }
                if (response.success) {
                  this.message = "Registration successfull!";
                  this.messageClass = "text-green-500";
                  if (
                    response.token !== null ||
                    response.token !== "" ||
                    response.token !== "undefined"
                  ) {
                    localStorage.setItem("authToken", response.token);
                  }
                  const redirectPath = this.$route.query.redirect || "/";
                  this.$router.push(redirectPath);
                } else {
                  this.message = response.error || "Registration failed!";
                  this.messageClass = "text-red-500";
                }
              } catch (error) {
                this.message =
                  error.message || "An error occured during registration";
                this.messageClass = "text-red-500";
              }
            }
          } catch (error) {
            console.error(error);
          }
        }
      } catch (err) {
        console.log("Error in Registration: ", err);
      } finally {
        this.googleLoading = false;
      }
    },
  },
};
</script>
